import React, { Component } from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Container from 'react-bootstrap/Container';
import { Button } from 'react-bootstrap';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipNextIcon from '@material-ui/icons/SkipNext';

const styles = theme => ({
    selectable: {
        cursor: "pointer"
    },
    colorBlue: {
        color: "blue"
    },
    root: {
        display: 'flex',
        marginBottom: "10px"
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
        backgroundSize: "contain !important"
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
});

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount(){
        document.title = "Pupitres | Entrenamiento Moodle";
    }

    render() {
        const { toggleMenu, classes, theme } = { ...this.props };

        return (
            <Container fluid={false}>
                <Row>
                    <Col>
                        <h1>¡Bienvenido al sitio de entrenamiento de Moodle de Pupitres!</h1>
                        <p>
                            Acá podrás aprender a usar Moodle a través de videos explicativos hechos por <a href="https://pupitres.net/contacto/">Pupitres. </a>
                            Aprende según tu rol: Docente, estudiante o administrador.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card className={classes.root}>
                            <CardMedia
                                className={classes.cover}
                                image="https://www.artlicensinginfo.com/wp-content/uploads/2015/08/noun_book_91270.png"
                                title=""
                            />
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Typography component="h5" variant="h5">
                                        ¿Cómo usar el sitio de entrenamiento?
                                    </Typography>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        <a style={{ cursor: "pointer" }} onClick={() => toggleMenu(true)} className={``}>Abre el menú </a>
                                         de los videos o digita el tema que buscas en el buscador.
                                        Reproduce el video y sigue el paso a paso en el panel de la derecha.
                                        Practica en tu sitio de Moodle.

                                    </Typography>
                                </CardContent>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card className={classes.root}>
                            <CardMedia
                                className={classes.cover}
                                image="https://icons-for-free.com/iconfiles/png/512/friends+icojam+link+material+share+icon-1320184944109183546.png"
                                title=""
                            />
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Typography component="h5" variant="h5">
                                        Comparte el sitio con tus colegas
                                    </Typography>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Subiremos nuevos videos, por lo que sugerimos te suscribas a nuestro <a href="https://www.youtube.com/channel/UCygJve_IvOVCqpGLxJuorkw?view_as=subscriber">canal en YouTube</a>.
                                        No olvides dejarnos tus comentarios y solicitarnos videos que no hayamos incluido.
                                    </Typography>
                                </CardContent>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card className={classes.root}>
                            <CardMedia
                                className={classes.cover}
                                image="https://icons-for-free.com/iconfiles/png/512/envelope-131965017430203317.png"
                                title=""
                            />
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Typography component="h5" variant="h5">
                                        ¿Tu institución necesita ayuda?
                                    </Typography>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Brindamos alojamiento, mantenimiento, soporte y capacitaciones en Moodle.
                                        Mándanos un mensaje por <a href="https://pupitres.net/contacto/">aquí</a> o al correo <a href="mailto:pupitres@pupitres.net">pupitres@pupitres.net</a> y te responderemos en breve.
                                        <br />
                                        ¡Esperamos haberte ayudado!
                                        <br /><br />
                                        Pupitres
                                    </Typography>
                                </CardContent>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withStyles(styles)(Welcome);